import { jsx as _jsx } from "react/jsx-runtime";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import { PropertyListItem } from "../PropertyListItem";
export var PropertyList = function (_a) {
    var _b = _a.properties, properties = _b === void 0 ? [] : _b, getActions = _a.getActions;
    return (_jsx(Stack, { direction: "column", gap: 2, divider: _jsx(Divider, { orientation: "horizontal" }), children: properties.map(function (property) { return (_jsx(PropertyListItem, { property: property, getActions: getActions })); }) }));
};
